function isE2EAccount(email) {
  const E2E_ACCOUNTS_PATTERN = /^e2e.test/i

  return E2E_ACCOUNTS_PATTERN.test(email)
}

export default isE2EAccount
